
function SightsEn() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/city-img/sights_banner.JPG" alt="sights" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Wismar's sights</h1>
                            <p>In addition to breathtaking church buildings, there are many more medieval buildings 
                                and historical sites to marvel at in Wismar. It is worth wandering through the many 
                                streets and small side streets, each of which has its own discoveries in store. 
                                Without a specific destination, it is almost the best way to explore the city and its 
                                buildings, which date back several centuries. Curious to find out more? Then you'll 
                                find a little taster of your next exploration tour here.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Wasserkunst</h2>
                            <p>The Wasserkunst is one of Wismar's most famous landmarks and is located on the market 
                                square, the largest of its kind in northern Germany. The richly decorated fountain from 
                                the 16th century was once used to supply water and is now a popular meeting place and photo 
                                motif.<br></br>Until the end of the 19th century, it was not possible to simply turn on the 
                                tap in Wismar, water had to be fetched from wells. There were several places to do this, but 
                                the Wasserkunst was probably the most beautiful. Every now and then, the Wasserkunst can be 
                                visited from the inside as part of a guided tour.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Gewölbe</h2>
                            <p>The "Gewölbe" is actually a historic half-timbered house that was built in the 17th century 
                                directly above the small pit river that runs through Wismar and was originally part of the 
                                town fortifications. Although some parts of the building are already subject to gravity, it 
                                is a popular photo motif and almost as typical of Wismar as the Wasserkunst.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Frische Grube and Mühlengrube</h2>
                            <p>These two historic watercourses run through Wismar and bear witness to the city's former 
                                water supply. Today they are picturesque promenades lined with old half-timbered houses 
                                and gardens. At the end of the mill pit is the town mill, now an industrial monument.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Oldest residential building</h2>
                            <p>The oldest residential building in Wismar dates back to 1430 and impresses with its 
                                well-preserved brick architecture. At just 4.80 metres wide, it is one of the more 
                                unusual buildings. It is located at Dankwartstraße 8 and bears witness to the way of 
                                life at that time.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Schabbellhaus</h2>
                            <p>The Schabbellhaus is Wismar's town history museum. It offers exciting exhibitions on the 
                                history of the Hanseatic city and also impresses with its magnificent facade from the 
                                Renaissance period. It was built in the 16th century for the later mayor Hinrich Schabbell.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Fürstenhof</h2>
                            <p>The Fürstenhof was once the residence of the Dukes of Mecklenburg and is one of the most 
                                important Renaissance buildings in northern Germany. Today it houses parts of the district 
                                court and is an architectural highlight.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Lindenpark</h2>
                            <p>The Lindenpark is a green oasis in Wismar that was built in 1815 and is ideal for relaxing 
                                walks or a picnic. The park is particularly worth a visit in spring and summer when the 
                                lime trees are in full bloom. The Mühlenbach stream meanders through here too, and at the 
                                north-western end is the Old Water Tower, an old defence tower of the former Swedish citadel, 
                                on whose grounds the listed park was created.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Karstadt</h2>
                            <p>Rudolph Karstadt opened his first shop in Wismar in 1881 and today's Karstadt building was 
                                erected in 1907. It is the flagship store of Karstadt AG and was the go-to place for 
                                department stores in the 20th century. Even in the age of Amazon & Co. you can still buy 
                                goods here in the traditional way as in the previous century. In the Kontor, the Rudolph 
                                Karstadt Museum, the history and work of the former merchant can be traced.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Former fire station</h2>
                            <p>The former fire station is one of the most impressive buildings of the last century. It 
                                was built in the 1920s and, with its expressionist architectural style, is one of the 
                                late buildings in the Hanseatic city.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default SightsEn;